import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { DELETE_DOMAIN } from './mutation'
import { Data, UseDeleteDomain, UseDeleteDomainProps, Variables } from './types'

export const useDeleteDomain = ({ name }: UseDeleteDomainProps): UseDeleteDomain => {
  const { t } = useTranslation('features/domain')
  const { enqueueSnackbar } = useSnackbar()

  const { isPending: loading, mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: DELETE_DOMAIN,
    onCompleted: async (data: Data) => {
      const { deleteDomain } = data

      if (deleteDomain) {
        const { errors } = deleteDomain

        if (errors && errors.length > 0) {
          enqueueSnackbar(t('delete.action.error', { domainName: name }), { variant: 'error' })
        }
      } else {
        enqueueSnackbar(t('delete.action.success', { domainName: name }), { variant: 'success' })
      }
    },
    queriesToInvalidate: ['getDomainsForTable'],
  })

  const deleteDomain: UseDeleteDomain['deleteDomain'] = id => void mutateAsync({ input: { id } })

  return { deleteDomain, loading }
}
